import React from 'react';
import SortableTable from './SortableTable';
//TODO: import dataSet in page using tables
// import { equipment as dataSet } from '../../data/equipment.json';
// const testTitles = ['Name', 'Quantity'];

export default class SortableTableContainer extends React.Component {
  state = {
    tableData: [],
    sortOrder: '',
    sortColumn: '',
    headerTitles: []
  };

  componentWillMount() {
    this.setState({
      tableData: this.props.tableData,
      sortOrder: 'ascending',
      sortColumn: 'column1',
      headerTitles: ['Name', 'Quantity']
    });
  }
  render() {
    return (
      <SortableTable
        headerTitles={this.state.headerTitles}
        tableData={this.state.tableData}
      />
      // TODO: add `tableData` props
      // e.g. <SortableTable tableData={this.props.tableData} headerTitles={this.props.headerTitles} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SortableTable/SortableTableContainer.js